import "./skeleton.css";

const Skeleton = ({ style, className }) => {
  return <div style={style} className={`skeleton ${className}`}></div>;
};
export default Skeleton;
